import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { RoutesPaths } from "../../Router/constant";
import { useDispatch, useSelector } from "react-redux";
import { backendUrl } from "../../constants";
import { getBannerAction } from "../../Action/banner";
import { getQuestionAction, deleteQuestionAction } from "../../Action/question";

export default function Questions() {
  const { questionsList, count } = useSelector((state) => state.question);

  const dispatch = useDispatch();
  const [showPopup, setShowPopup] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const recordsPerPage = 10;
  const totalPages = Math.ceil(count / recordsPerPage);

  useEffect(() => {
    dispatch(getQuestionAction(currentPage, recordsPerPage));
  }, [dispatch, currentPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const generatePageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbers = 5; // Adjust this to show more/less page numbers

    if (totalPages <= maxPageNumbers) {
      for (let i = 0; i < totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      const halfPageNumbers = Math.floor(maxPageNumbers / 2);
      let startPage = Math.max(currentPage - halfPageNumbers, 0);
      let endPage = Math.min(startPage + maxPageNumbers - 1, totalPages - 1);

      if (currentPage > totalPages - halfPageNumbers) {
        startPage = totalPages - maxPageNumbers;
      }

      for (let i = startPage; i <= endPage; i++) {
        pageNumbers.push(i);
      }
    }

    return pageNumbers;
  };

  const handleError = (event) => {
    event.target.src = "assets/img/dummy-image-square.jpg"; // fallback image
  };

  const handleShow = (id) => {
    setSelectedId(id);
    setShowPopup(true);
  };
  const handleClose = () => setShowPopup(false);
  const handleYes = (id) => {
    dispatch(deleteQuestionAction(id))
      .then(() => {
        setShowPopup(false);
        dispatch(getQuestionAction(currentPage, recordsPerPage));
      });
  };

  const AlertPopup = ({ show, handleClose, handleYes, id }) => {
    return (
      <div
        className={`modal modal-confirmation ${show ? "show" : ""}`}
        style={{ display: show ? "block" : "none" }}
      >
        <div className="modal-content">
          <span className="close" onClick={handleClose}>
            &times;
          </span>
          <h2>Confirmation</h2>
          <p>Are you sure you want to delete this service?</p>
          <div className="modal-footer">
            <button className="secondary" onClick={handleClose}>
              No
            </button>
            <button className="primary" onClick={() => handleYes(id)}>
              Yes
            </button>
          </div>
        </div>
      </div>
    );
  };
  return (
    <>
      <AlertPopup
        show={showPopup}
        handleClose={handleClose}
        handleYes={handleYes}
        id={selectedId}
      />
      <div className="app-main flex-column flex-row-fluid" id="kt_app_main">
        <div className="d-flex flex-column flex-column-fluid">
          <div id="kt_app_toolbar" className="app-toolbar pt-7 pt-lg-10">
            <div
              id="kt_app_toolbar_container"
              className="app-container container-fluid d-flex align-items-stretch"
            >
              <div className="app-toolbar-wrapper d-flex flex-stack flex-wrap gap-4 w-100">
                <div className="page-title d-flex flex-column justify-content-center gap-1 me-3">
                  <h1 className="page-heading d-flex flex-column justify-content-center text-gray-900 fw-bold fs-3 m-0">
                    Question & Answer
                  </h1>
                  <ul className="breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0">
                    <li className="breadcrumb-item text-muted">
                      Over {count} Question
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div id="kt_app_content" className="app-content flex-column-fluid">
            <div
              id="kt_app_content_container"
              className="app-container container-fluid"
            >
              <div className="card">
                <div className="card-header border-0 pt-6 customCategoryHeader">
                  <div className="card-title">
                    <div className="d-flex align-items-center position-relative my-1">
                      {/* <i className="ki-outline ki-magnifier fs-3 position-absolute ms-5" />
                      <input
                        type="text"
                        data-kt-user-table-filter="search"
                        className="form-control form-control-solid w-250px ps-13"
                        placeholder="Search banner"
                      /> */}
                    </div>
                  </div>

                  <NavLink
                    to={{
                      pathname: RoutesPaths.QUESTIONS,
                    }}
                    className="btn btn-flex btn-center btn-sm"
                  >
                    <div className="">
                      <button
                        id="kt_account_deactivate_account_submit"
                        type="submit"
                        className="btn btn-success fw-semibold colorGreen"
                      >
                        Add Question
                      </button>
                    </div>
                  </NavLink>
                </div>
                <div className="card-body py-4">
                  <table
                    className="table align-middle table-row-dashed fs-6 gy-5"
                    id="kt_table_users"
                  >
                    <thead>
                      <tr className="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
                        {/* <th className="min-w-125px">Banner Image</th> */}
                        <th className="min-w-125px">Question</th>
                        <th className="min-w-125px">answer</th>
                        <th className="min-w-200px">Other</th>
                        <th className="min-w-200px">Active</th>
                        <th className="text-center min-w-100px">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="text-gray-600 fw-semibold">
                      {questionsList?.length > 0 ? (
                        questionsList.map((qa, index) => {
                          return (
                            <tr key={index}>
                              {/* <td>
                                <img
                                  src={backendUrl + banner.image}
                                  alt=""
                                  className="categoryImage"
                                  onError={handleError} // handle the error event
                                />
                              </td> */}
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {qa?.question}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {JSON.stringify(qa?.answers?.length)}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {JSON.stringify(qa?.isOther)}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex flex-column">
                                  <span className="text-gray-800 mb-1">
                                    {JSON.stringify(qa?.isActive)}
                                  </span>
                                </div>
                              </td>
                              <td className="td-last">
                                {/* <NavLink
                                  // to={RoutesPaths.BANNER}
                                  // state={{ banner: banner }}
                                  className="btn btn-light btn-active-light-primary btn-flex btn-center btn-sm me-2"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  View
                                </NavLink> */}

                                <NavLink
                                  to={RoutesPaths.QUESTIONS}
                                  state={{ question: qa }}
                                  className="btn btn-light btn-active-primary btn-light-primary btn-flex btn-center btn-sm"
                                  data-kt-menu-trigger="click"
                                  data-kt-menu-placement="bottom-end"
                                >
                                  Edit
                                </NavLink>
                                <button
                                  type="button"
                                  className="btn btn-danger fw-semibold colorGreen"
                                  onClick={() => handleShow(qa._id)}
                                >
                                  Delete
                                </button>

                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="4" className="text-center">
                            No question available.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-center">
                    <button
                      className="btn btn-primary"
                      onClick={() => handlePageChange(0)}
                      disabled={currentPage === 0}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-double-left"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M11.354 1.646a.5.5 0 0 1 0 .708L6.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0zM7.354 1.646a.5.5 0 0 1 0 .708L2.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z"
                        />
                      </svg>
                    </button>
                    <button
                      className="btn btn-primary mx-2"
                      onClick={() => handlePageChange(currentPage - 1)}
                      disabled={currentPage === 0}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-left"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M11.354 1.646a.5.5 0 0 1 0 .708L6.707 7l4.647 4.646a.5.5 0 0 1-.708.708l-5-5a.5.5 0 0 1 0-.708l5-5a.5.5 0 0 1 .708 0z"
                        />
                      </svg>
                    </button>

                    {generatePageNumbers().map((page, index) => (
                      <button
                        key={index}
                        className={`btn btn-light btn-active-light-primary mx-1 ${page === currentPage ? "active" : ""
                          }`}
                        onClick={() => handlePageChange(page)}
                      >
                        {page + 1}
                      </button>
                    ))}

                    <button
                      className="btn btn-primary mx-2"
                      onClick={() => handlePageChange(currentPage + 1)}
                      disabled={currentPage === totalPages - 1}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-right"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L9.293 7 4.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => handlePageChange(totalPages - 1)}
                      disabled={currentPage === totalPages - 1}
                    >
                      <svg
                        width="16"
                        height="16"
                        fill="currentColor"
                        className="bi bi-chevron-double-right"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          d="M4.646 1.646a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L9.293 7 4.646 2.354a.5.5 0 0 1 0-.708zm4 0a.5.5 0 0 1 .708 0l5 5a.5.5 0 0 1 0 .708l-5 5a.5.5 0 0 1-.708-.708L13.293 7 8.646 2.354a.5.5 0 0 1 0-.708z"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
